/**
 * 收货地址格式校验（与 PC / 支付页 dizhiform 统一）
 *
 * 提出订单选地址、新增地址、支付页付款三处必须用同一套规则，
 * 否则订单能提交、支付页却过不了校验。
 * 这里只放纯函数，不依赖 Vue 实例；文案由调用方传入 $fanyi。
 */

// 允许的邮箱后缀白名单（与支付页 dizhiform 保持一致）
export const EMAIL_POSTFIX_LIST = [
  'qq.com',
  '163.com',
  'fastmail.com',
  'me.com',
  'email.com',
  'gmail.com',
  '126.com',
  'yahoo.com',
  'sina.com',
  'games.com',
  'rocketmail.com',
  'wow.com',
  'googlemail.com',
  'comcast.net',
  'warwick.net',
  'comcast.net',
  'twcny.rr.com',
  'hotmail.com',
  'foxmail.com',
  'rakumartwork.com',
  'outlook.com',
  'facebook.com',
  'mail.com',
  'mac.com',
  'icloud.com',
  'zoho.com',
  'ymail.com',
  'ygm.com',
  'love.com',
  'aol.com',
  'verizon.net',
  'cs.com',
  'netzero.net',
  'rakumart.eu',
]

// 邮编：5 位字母或数字
export const ZIP_CODE_REG = /^(\w){5}$/
// 手机号：10 位字母或数字
export const MOBILE_REG = /^(\w){10}$/
// 邮箱基础格式
export const EMAIL_REG = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** 去掉首尾空格，非字符串统一转字符串 */
const trim = (val) => (val === undefined || val === null ? '' : String(val).trim())

/** 邮编是否合法 */
export const isValidZipCode = (val) => ZIP_CODE_REG.test(trim(val))

/** 手机号是否合法 */
export const isValidMobile = (val) => MOBILE_REG.test(trim(val))

/**
 * 邮箱是否合法：基础格式 + 后缀白名单
 * @param {String} val 邮箱
 */
export const isValidEmail = (val) => {
  const email = trim(val)
  if (!EMAIL_REG.test(email)) return false
  const index = email.indexOf('@')
  const postfix = email.substr(index + 1, email.length).toLowerCase()
  return EMAIL_POSTFIX_LIST.indexOf(postfix) !== -1
}

/**
 * 校验一条收货地址是否满足支付页要求
 * @param {Object} addr 地址对象
 * @param {Function} fanyi 翻译函数
 * @returns {String} 第一条错误提示；全部通过返回空字符串
 */
export const validateAddress = (addr, fanyi) => {
  const t = typeof fanyi === 'function' ? fanyi : (msg) => msg
  const data = addr || {}

  // 必填字段：与支付页 formRules 的 required 保持一致
  const requiredFields = [
    { key: 'contacts', label: '收件人' },
    { key: 'state', label: '州' },
    { key: 'city', label: '城市' },
    { key: 'address', label: '地址' },
    { key: 'zip_code', label: '邮编' },
    { key: 'mobile', label: '手机号' },
    { key: 'email', label: '邮箱' },
  ]
  for (const field of requiredFields) {
    if (!trim(data[field.key])) {
      return t(`${field.label}不能为空`)
    }
  }

  // 格式校验顺序与支付页提示保持一致
  if (!isValidZipCode(data.zip_code)) return t('邮编输入错误')
  if (!isValidMobile(data.mobile)) return t('请输入正确的手机号')
  if (!isValidEmail(data.email)) return t('请输入正确的邮箱地址')

  return ''
}

export default {
  EMAIL_POSTFIX_LIST,
  ZIP_CODE_REG,
  MOBILE_REG,
  EMAIL_REG,
  isValidZipCode,
  isValidMobile,
  isValidEmail,
  validateAddress,
}
